import React from "react";
import { useStore } from "../../store";
import Ttable from "../TotalExpenseReport/UserStyledTable";

interface IReport {
  data: any;
  companyId?: any;
  companyName?: any;
  reportType?: string;
}
const Report: React.FC<IReport> = (props) => {
  const [state, dispatch]: any = useStore();

  if (props.data.length === 0) {
    return (
      <>
        <br />

        <div
          style={{
            borderTop: "1.5px solid red",
            textAlign: "center",
            color: "red",
            fontSize: "16px",
            marginTop: "10px",
            paddingTop: "5px",
          }}
        >
          No data found !...
        </div>
      </>
    );
  }
  return (
    <Ttable
      companyId={props.companyId}
      companyName={props.companyName}
      reportType={props.reportType}
      tableTitle="Food Expense Report"
      tableHeadList={[
        "Food Item",
        "Quantity",
        "Rate",
        "Amount",
        "Vat Amount",
        "Total amount",
      ]}
    >
      {props.data &&
        props.data.data.map((item: any, index: any) => {
          return (
            <tr key={index} className="tableTr">
              <td
                style={{
                  textTransform: "capitalize",
                }}
              >
                {item?.food_item}
              </td>
              <td className="Email">{item?.quantity}</td>
              <td>{item?.rate.toFixed(2)}</td>
              <td>{item?.amount.toFixed(2)}</td>
              <td>{item?.vat_amount.toFixed(2)}</td>
              <td>{item?.total_amount.toFixed(2)}</td>
            </tr>
          );
        })}
    </Ttable>
  );
};

export default Report;
